import {
  TDate,
  TNptReasonWithDisplayName,
  TRESPONSE_LINES_NPT_DETAILS,
  TRESPONSE_NPT_REASONS_LIST,
  TRESPONSE_WORKSTATIONS_NPT_DETAILS,
  TRESPONSE_WORKSTATION_NPTS,
  TUserPaginationOption,
} from '@monorepo/types';

export interface TNptState {
  nptLinesDetails: TRESPONSE_LINES_NPT_DETAILS | null;
  nptWorkstationsGroups: TRESPONSE_WORKSTATIONS_NPT_DETAILS['workstationGroups'] | null;
  workstationsNpts: TRESPONSE_WORKSTATION_NPTS['npts'] | null;
  selectedDate: TDate;
  nptReasons: TNptReasonWithDisplayName[];
  nptReasonsList: TRESPONSE_NPT_REASONS_LIST | null;
  nptReasonsListPaginationOption: TUserPaginationOption;
}

export const MAX_DAYS_FOR_PAST_NPT_EDIT = 1;
export const MAX_DAYS_FOR_PAST_NPT_DELETE = 1;
export const NPT_REASONS_UPLOAD_DEFAULT_PAGINATION_OPTION: TUserPaginationOption = {
  pageNo: 1,
  pageSize: 10,
};

export const TNptActionTypes = {
  GetNptLinesDetails: 'GET_NPT_LINES_DETAILS' as const,
  GetNptLinesDetailsSuccess: 'GET_NPT_LINES_DETAILS_SUCCESS' as const,
  GetNptLinesDetailsFailure: 'GET_NPT_LINES_DETAILS_FAILURE' as const,
  GetNptWorkstationsDetails: 'GET_NPT_WORKSTATIONS_DETAILS' as const,
  GetNptWorkstationsDetailsSuccess: 'GET_NPT_WORKSTATIONS_DETAILS_SUCCESS' as const,
  GetNptWorkstationsDetailsFailure: 'GET_NPT_WORKSTATIONS_DETAILS_FAILURE' as const,
  NptSetSelectedDate: 'NPT_SET_SELECTED_DATE' as const,
  SetNptReasons: 'SET_NPT_REASONS' as const,
  GetWorkstationsNpts: 'GET_WORKSTATIONS_NPTS' as const,
  GetWorkstationsNptsSuccess: 'GET_WORKSTATIONS_NPTS_SUCCESS' as const,
  GetWorkstationsNptsFailure: 'GET_WORKSTATIONS_NPTS_FAILURE' as const,
  FetchNptReasonsList: 'FETCH_NPT_REASONS_LIST' as const,
  FetchNptReasonsListSuccess: 'FETCH_NPT_REASONS_LIST_SUCCESS' as const,
  FetchNptReasonsListFailure: 'FETCH_NPT_REASONS_LIST_FAILURE' as const,
  SetReasonsListPaginationOption: 'SET_REASONS_LIST_PAGINATION_OPTION' as const,
};
